<template>

<v-app id="view_pedimento">
<v-container>
    <v-row align="start" class="pa-0" >
        <v-col cols="12" sm="12" lg="12" class="pa-3">
                    <img src="/static/logo_negro.png" alt="proControl" style="height:32px" />
        </v-col>
    </v-row>
    <v-row  v-if="(informacion_bosch!='' && pass_ok)">
        <v-col cols="12" sm="12" lg="12">
            <table width="100%" class="both">
                <tr>
                    <td width="10%" align="right"><b>Maquina no.</b></td>
                    <td width="1%"></td>
                    <td width="89%">{{informacion_bosch['no_maquina']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Línea</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['linea']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Marca</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['marca']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Modelo</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['modelo']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Descripción</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['descripcion']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Serie</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['serie']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Observaciones</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['observaciones']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Edificio</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['edificio']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>STATUS</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['estatus']}}</td>
                </tr>
                <tr>
                    <td align="right"><b>Planta</b></td>
                    <td width="1%"></td>
                    <td>{{informacion_bosch['planta_referencia']}}</td>
                </tr>
            </table>            
        </v-col>
    </v-row>
    <v-row  class="pa-0" align="start" v-if="pass_ok">
        <v-col cols="4" sm="4" lg="4" class="pa-3 pb-0">
            <v-autocomplete v-model="eltipo" :items="tipos" :hide-no-data="true" :return-object="false" @change="active=[]" label="Tipo" item-text="name" item-value="value">
            </v-autocomplete>
        </v-col>
        <v-col cols="8" sm="8" lg="8" class="pa-3 pb-0">
            <v-autocomplete v-if="eltipo=='de_pedimentos'" v-model="active[0]" :items="de_pedimentos" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
             <v-autocomplete v-if="eltipo=='de_coves'" v-model="active[0]" :items="de_coves" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
             <v-autocomplete v-if="eltipo=='de_edoc'" v-model="active[0]" :items="de_edoc" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
             <v-autocomplete v-if="eltipo=='de_adjuntos'" v-model="active[0]" :items="de_adjuntos" :hide-no-data="true" @change="preview" :return-object="true" label="Archivo" item-text="name" >
            </v-autocomplete>
        </v-col>
    </v-row>

    <v-row align="start" class="pa-0"  >
        <v-col cols="12" sm="12" lg="12" class="pa-5 pt-0 "  >
              <v-flex xs12 style="margin-top:20px" >
                                <v-card class="mx-auto primary" height="620px"  v-if="active.length > 0" >
                                    <v-card-title class="primary white--text" >
                                        <v-icon small class="white--text" >search</v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>Vista Previa</strong>
                                        </span>
                                    </v-card-title>
                                    <v-card-text>
                                        <br />
                                       
                                        <table class="table table-condensed white--text" >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <span id="lab_title_file" >Año:</span>
                                                        <strong>
                                                            <span id="lab_file" >{{active[0].dir.split("/")[2]}}</span>
                                                        </strong>
                                                    </td>
                                                   
                                                    <td>Tamaño:</td>

                                                    <td>
                                                        <strong>
                                                            <span id="lab_size" >{{active[0].size}}MB</span>
                                                        </strong>
                                                    </td>

                                                    <td style="padding-top:5px !important;" >
                                                        
                                                        <v-btn v-if="active[0].file != 'grupo'" rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                                                            <v-icon small>mdi-download</v-icon>Descargar
                                                        </v-btn>
                                                       
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div v-if="active[0].file.toUpperCase() =='XML' || active[0].file.toUpperCase() =='TXT' ||  parseInt(active[0].file)  > 0  || active[0].file.toUpperCase()  =='ERR'" class="global" >
                                            <div class="contenidotxt" >
                                                <pre>{{xmlContent}} </pre>
                                            </div>
                                        </div>

                                        <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' " >
                                            <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored" ></PDFViewer>
                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='JPG' || active[0].file.toUpperCase() =='JPEG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/jpg;base64,${url}`" max-width="900px" ></v-img>                                                
                                            </div>

                                        </div>
                                        <div v-if="active[0].file.toUpperCase() =='PNG'" class="global" >
                                            <div class="contenido" >
                                                <v-img :src="`data:image/png;base64,${url}`" max-width="900px" ></v-img>
                                            </div>

                                        </div>
                                        <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF'  
                                        && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='JPG' && active[0].file.toUpperCase()  !='JPEG' && active[0].file.toUpperCase()  !='TXT' 
                                        && active[0].file !=''  && !parseInt(active[0].file)>0  && active[0].file.toUpperCase()  !='ERR' " >Vista previa no disponible.
                                        </v-alert>

                                    </v-card-text>
                                </v-card>
                            </v-flex>
        </v-col>
    </v-row>
    </v-container>

    <v-dialog v-model="modalPass" persistent max-width="250px" style=" z-index: 400 !important;" >
        <v-card>
            <v-card-title>
                <v-card class="primary white--text titulomodal" >
                    <span class="subheading" >
                        <strong>Código de Acceso</strong>
                    </span>
                </v-card>
                <v-spacer></v-spacer>                
            </v-card-title>
            <v-card-text>      
                <v-form ref="formpass" lazy-validation> 
                    <v-row justify="center">
                        <v-col cols="12" sm="12" md="12" lg="12" style="text-align:center !important;">
                            <v-text-field label="Código" v-model="codigo_acceso" 
                                ref="ingresapass" v-on:keydown.enter.prevent='1' 
                                @keyup.enter="validaPass()" maxlength="10"
                                :rules="[rules.required]"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.native="validaPass()">
                    <v-icon>done</v-icon> Aceptar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-app>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";

export default {
    components: {
        PDFViewer
    },
    created() {
        this.id_etiqueta = this.$route.params.id_etiqueta;
        this.id_pedimento = this.$route.params.id_pedimento;
        
        this.id_etiqueta_pedimento_bosch = this.$route.params.id_etiqueta_pedimento_bosch!=undefined ? this.$route.params.id_etiqueta_pedimento_bosch: "";
        //console.log("BOSCH: ",this.id_etiqueta_pedimento_bosch);
        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        let data = {
            id_etiqueta: this.id_etiqueta,
            id_pedimento: this.id_pedimento,
            id_etiqueta_pedimento_bosch: this.id_etiqueta_pedimento_bosch //Solo aplica para los QR d BOSCH
        };

        axios.post(this.$hostname + "s3/get_pedimento/", data)         
            .then(res => {

                if (typeof res.data !== 'undefined') {

                    this.search = res.data["no_pedimento"];
                    this.$local_storage.set("rfc", res.data["rfc"]);
                    //Solo aplica para QR d Bosch                    
                    this.informacion_bosch = res.data["informacion_bosch"]!=undefined ? res.data["informacion_bosch"] : "";
                    //Si tiene password hay que pedirlo y validarlo antes de buscar el pedimento:
                    if (res.data["pass"] && res.data["pass"] != "No"){                        
                        this.$root.$dialogLoader.hide();
                        this.modalPass = true;
                        this.pass_ok = false;
                    } else {
                        this.pass_ok = true;
                        this.buscar();
                    }
                    

                } else {
                    this.url = "";

                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "No se encontró el archivo",
                        footer: '',
                    });
                }

            })
            .catch(error => {
                console.log(error);

                //Guardar etiqueta en log_etiquetas de mariadb cuando no se encuentre                
                axios.post(this.$hostname + "s3/guardar_log/", data)
                    .then(res => {                        
                    }).catch(error => {
                        console.log("Error al guardar log etiqueta",error);
                    });                

                if(parseInt(this.id_pedimento) == 0){ //Si el pedimento es cero buscar solo la informacion de las etiquetas
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios.post(this.$hostname + "s3/get_pedimento_cero/", data)         
                        .then(res => {

                            if (typeof res.data !== 'undefined') {

                                this.informacion_bosch = res.data["informacion_bosch"]!=undefined ? res.data["informacion_bosch"] : "";
                                this.pass_ok = true;                                

                            } else {
                                this.url = "";

                                this.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "No se encontró el archivo",
                                    footer: '',
                                });
                            }

                        })
                        .catch(error => {
                            console.log(error);
                            var mensaje = "Ocurrió un error al obtener el pdf de pedimento. Por favor intente nuevamente.";
                            if (error.response != null && error.response.data != null && error.response.data.mensaje != null) {
                                mensaje = error.response.data.mensaje
                            }

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: mensaje,
                                footer: ""
                            });

                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                        });
                } else {                    
                    //Si no se encuentra la etiqueta de todos modos mostrar el PDF, si el pedimento no es cero 
                    axios.post(this.$hostname + "s3/get_pedimento_numero/", {"id_pedimento": this.id_pedimento})
                        .then(respuesta => {
                            this.search = respuesta.data["no_pedimento"];
                            this.$local_storage.set("rfc", respuesta.data["rfc"]);

                            axios.post(this.$hostname + "s3/get_pass/", {"rfc": respuesta.data["rfc"]})                            
                            .then(res => {
                                if (res.data["pass"] && res.data["pass"] != "No"){                        
                                    this.$root.$dialogLoader.hide();
                                    this.modalPass = true;
                                    this.pass_ok = false;
                                } else {
                                    this.pass_ok = true;
                                    this.buscar();
                                }
                            }).catch(error => {
                                console.log("Error al get_pass",error);
                            });
                            
                        }).catch(error => {
                            console.log("Error al get_pedimento_numero",error);
                        });                    
                }
                

                /*var mensaje = "Ocurrió un error al obtener el pdf de pedimento. Por favor intente nuevamente.";
                if (error.response != null && error.response.data != null && error.response.data.mensaje != null) {
                    mensaje = error.response.data.mensaje
                }

                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: mensaje,
                    footer: ""
                });*/

            })
            .then(() => {
                this.$root.$dialogLoader.hide();
            });

    },
    methods: {
        validaPass: function(){
            if (this.$refs.formpass.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                let data = {
                    "rfc": this.$local_storage.get("rfc"),
                    "codigo": this.codigo_acceso
                };

                axios.post(this.$hostname + "reportes_ws/valida_pass_etiqueta/", data)         
                    .then(res => {
                        this.modalPass = false;
                        this.pass_ok = true;
                        this.buscar();
                }).catch(error => {
                    console.log(error);                    
                    this.$swal({
                        type: "error",
                        title: "¡Código Incorrecto!",
                        text: "",
                        footer: ""
                    });

                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });


            }
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        preview() {
            // Para eliminar todo el expediente
            this.borrableExpediente = false;
            if (this.active.length > 0 && Number.isInteger(this.active[0].id) && this.active[0].file == "folder") {
                this.borrableExpediente = true;
            }

            this.borrable = !this.active.length || this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

            if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                return undefined;
            }

            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG" || this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: "production.econnect.ds"
                }
                this.xmlContent = "";
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML") {
                                this.xmlContent = beautify(atob(response.data));
                            }
                            if (this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                                this.xmlContent = atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG") {
                                this.url = response.data
                            }
                        } else {
                            this.url = "";

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        this.url = "";
                        this.xmlContent = ""
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.$swal({
                                type: "info",
                                title: "Importante",
                                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                cancelButtonText: "Cancelar"
                            }).then(result => {
                                if (result.value) {
                                    this.downloadFileUrl(datos.id);
                                } else {
                                    this.$root.$dialogLoader.hide();
                                }
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                if (this.active[0].file.toUpperCase() == "XML") {
                    this.downloadFile(this.active[0].dir);
                } else {
                    try {
                        if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
                            this.downloadFileUrl(this.active[0].dir);
                        else
                            this.downloadFile(this.active[0].dir);
                    } catch (error) {
                        this.downloadFileUrl(this.active[0].dir);
                    }

                }
            }

        },

        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },

        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        buscar: function () {
            this.de_pedimentos = [];
            this.de_coves = [];
            this.de_edoc = [];
            this.de_adjuntos = [];
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.active = [];
            if (this.search === null) {
                this.$root.$dialogLoader.hide();
                return false;
            }
            var data = {
                rfc: this.$local_storage.get("rfc"),
                filename: this.search,
            };
            axios
                .post(this.$hostname + "reportes/get_consulta_file/", data)
                .then(res => {
                    var self = this;
                    self.items = [];
                    if (res.data.length > 0) {
                        res.data.forEach(function (item) {
                            var i = 1;
                            var children = [];
                            var coves = [];
                            var edocuments = [];
                            var remesas = [];
                            var adjuntos = [];
                            var af_file = [];
                            var size_partidas = 0;
                            var cuenta_partidas = 0;
                            var size_coves = 0;
                            var size_edocuments = 0;
                            var size_remesas = 0;
                            var size_adjuntos = 0;
                            var size_af = 0;
                            self.key = item.id;
                            item.validacion.forEach(function (v) {
                                if (v.size > 0) {
                                    v.size = (((v.size / 1024)) / 1024).toFixed(3);
                                }
                                if (v.estatus == 2) {
                                    if (v.tipo < 6 || v.tipo == 19 || v.tipo == 20) {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }
                                     if (v.tipo == 2 ) {
                                       self.active[0] = {
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        };
                                        self.preview();
                                    }

                                    if (v.tipo == 'remesas') {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 6) {
                                        size_partidas = size_partidas + parseFloat(v.size);
                                        cuenta_partidas += 1;
                                    }
                                    if ((v.tipo == 7 || v.tipo == 8 || v.tipo == 10)) {
                                        coves.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_coves = size_coves + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 11 || v.tipo == 12 || v.tipo == 14)) {
                                        edocuments.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "eDocuments/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_edocuments = size_edocuments + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 15 || v.tipo == 16 || v.tipo == 18)) {
                                        remesas.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_remesas = size_remesas + parseFloat(v.size);
                                    }
                                    i = i + 1;
                                }

                            });
                            self.de_pedimentos = self.de_pedimentos.concat(children);;

                            var carpetas_adjuntos = [];
                            let tiene_archivos_pedimento = false;
                            let tiene_AF = false;
                            item.adjuntos = item.adjuntos.sort(function (a, b) {
                                return a.filename > b.filename;
                            });
                            item.adjuntos.forEach(function (j) {
                                var sub = j.filename.split("_");
                                if (sub.length > 0) {
                                    if (carpetas_adjuntos.includes(sub[0]) == false) {
                                        if (sub[0] != 'P030' && sub[0] != 'P031' && sub[0] != 'P032' && sub[0] != 'P033' && !sub[0].toUpperCase().startsWith('AF')) {
                                            carpetas_adjuntos.push(sub[0]);
                                        } else {
                                            if (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033')
                                                tiene_archivos_pedimento = true;

                                        }
                                    }
                                }
                            });
                            if (tiene_archivos_pedimento) {
                                carpetas_adjuntos.push("ArchivosPedimento");
                            }
                            var l = 0;
                            var size = 0;
                            var child_af = [];
                            var child_af_size = 0;
                            carpetas_adjuntos.forEach(function (y) {
                                var child_adjuntos = [];
                                var child_adjuntos_size = 0;

                                var w = 1;
                                item.adjuntos.forEach(function (z) {
                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {
                                        if (sub[0] == y || (y == "ArchivosPedimento" && (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033'))) {
                                            sub = sub[0] + "/";
                                            child_adjuntos.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                                expediente: false
                                            });
                                            child_adjuntos_size = child_adjuntos_size + parseFloat(z.size);
                                        }

                                    }
                                    w = w + 1;

                                });
                                size = 0;
                                if (child_adjuntos_size > 0) {
                                    size = parseFloat((((child_adjuntos_size / 1024)) / 1024)).toFixed(3);
                                }
                                if (y == "ArchivosPedimento") {
                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        dir: "",
                                        file: "grupo",
                                        size: size,
                                        children: child_adjuntos,
                                        expediente: false
                                    });
                                } else {

                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        dir: item.path + "adjuntos/" + y,
                                        file: "folder",
                                        size: size,
                                        children: child_adjuntos,
                                        expediente: false
                                    });
                                }

                                size_adjuntos = size_adjuntos + parseFloat(child_adjuntos_size);

                                l = l + 1;
                            });

                            // llena los AF
                            item.adjuntos.forEach(function (z) {
                                size = 0;
                                if (z.size > 0) {
                                    size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                }
                                var sub = z.filename.split("_");
                                if (sub.length > 0) {

                                    if (sub[0].toUpperCase().startsWith('AF')) {
                                        sub = sub[0] + "/";
                                        child_af.push({
                                            id: sub + z.filename + "." + z.ext,
                                            name: z.filename + "." + z.ext,
                                            dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                            file: z.ext,
                                            size: size,
                                            expediente: false
                                        });
                                        child_af_size = child_af_size + parseFloat(z.size);
                                    }
                                }
                            });

                            if (cuenta_partidas > 0) {
                                let partidas = {
                                    id: "Partidas",
                                    name: "Partidas (" + cuenta_partidas + ").zip",
                                    dir: item.path + "partidas",
                                    file: "zip",
                                    size: size_partidas.toFixed(2),
                                    expediente: false
                                };
                                children.push(partidas);
                                // self.de_pedimentos = self.de_pedimentos.concat(partidas);  
                            }
                            if (coves.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_coves.toFixed(2),
                                    children: coves,
                                    expediente: false
                                });
                                self.de_coves = coves;

                            }
                            if (edocuments.length > 0) {
                                children.push({
                                    id: "Edocuments",
                                    name: "Edocuments",
                                    dir: item.path + "eDocuments",
                                    file: "folder",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments,
                                    expediente: false
                                });
                                self.de_edoc = edocuments;

                            }
                            if (remesas.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_remesas.toFixed(2),
                                    children: remesas,
                                    expediente: false
                                });
                                self.de_coves = self.de_coves.concat(remesas);
                            }

                            if (child_af.length > 0) {
                                children.push({
                                    id: "AFFILE",
                                    name: "AF_FILE",
                                    dir: item.path + "af_file",
                                    file: "folder",
                                    size: ((child_af_size / 1024) / 1024).toFixed(2),
                                    children: child_af,
                                    expediente: false
                                });
                                //self.de_adjuntos = child_af;
                                //Solo para esta vista en lugar de mostrar los folders se muestran directamente los archivos adjuntos
                                for(var k in child_af){
                                    //console.log("Adjunto AF: ", child_af[k]);                                    
                                    self.de_adjuntos.push(child_af[k])
                                }
                            }
                            if (adjuntos.length > 0) {
                                children.push({
                                    id: "Adjuntos",
                                    name: "Adjuntos",
                                    dir: item.path + "adjuntos",
                                    file: "folder",
                                    size: ((size_adjuntos / 1024) / 1024).toFixed(2),
                                    children: adjuntos,
                                    expediente: false
                                });
                                //self.de_adjuntos = self.de_adjuntos.concat(adjuntos);
                                //Solo para esta vista en lugar de mostrar los folders se muestran directamente los archivos adjuntos
                                for(var k in adjuntos){
                                    //console.log("Adjunto: ", adjuntos[k]);
                                    for(var kc in adjuntos[k].children){
                                        self.de_adjuntos.push(adjuntos[k].children[kc])
                                    }
                                }
                                
                                
                            }
                            var pathPedimento = self.$local_storage.get("rfc") + "/pedimentos/" + item.anio.toString();
                            if (item.path != null && item.path != undefined && item.path != "") {
                                pathPedimento = item.path
                            }
                            self.items.push({
                                id: item.id,
                                name: item.no_pedimento,
                                dir: pathPedimento,
                                file: "folder",
                                size: ((item.size / 1024) / 1024).toFixed(2),
                                children: children,
                                datastage: item.datastage,
                                expediente: true
                            });

                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "No se encontraron resultados",
                            text: this.search,
                            footer: ""
                        });
                    }
                    this.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al consultar el archivo",
                        footer: ""
                    });
                    console.log(err);
                });

        },

        downloadFile: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },

        downloadFileUrl: function (dir) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: dir,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
    },
    data: () => ({
        codigo_acceso:"",
        pass_ok: false,
        modalPass:false,
        id_etiqueta_pedimento_bosch: "",        
        informacion_bosch:"",
        de_pedimentos: [],
        de_coves: [],
        de_edoc: [],
        de_adjuntos: [],
        eltipo: "de_pedimentos",
        tipos: [
            {"name": "Pedimento", "value": "de_pedimentos" },
            {"name":"Coves", "value": "de_coves"},
            {"name":"Edocumnets", "value": "de_edoc"},
            {"name":"Adjuntos", "value": "de_adjuntos"}
        ],
        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        dialog1: false,
        confirm: false,
        confirmExpediente: false,
        confirmCarpeta: false,
        listado: "",
        files: {
            PDF: "mdi-file-pdf-box",
            PNG: "mdi-file-png-box",
            JPG: "mdi-file-jpg-box",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel-box",
            XLSX: "mdi-file-excel-box",
            DOCX: "mdi-file-word-box",
            DOC: "mdi-file-word-box",
            XML: "mdi-xml",
            ZIP: "mdi-zip-box"
        },
        tree: [],
        items: [],
        borrable: false,
        rules: {
            required: v => !!v || "Este campo es requerido"
        },
        borrableExpediente: false,
        borrableCarpeta: false,
        comentario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Consultar Expediente",
                disabled: true,
                to: ""
            }
        ],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 480px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
    background-color: white;
}

.contenidotxt {
    padding: 5px;
    font-size: small;
    overflow: auto;
    font-size: 12px !important;
    background-color: white;
}

.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}

.table {
    font-size: 12px !important;
    margin-bottom: 20px;
}

.v-label {
    font-size: 8px !important;
}
.both {
	border-collapse: collapse !important;
}
</style>
